export const transContsList = evaData =>
  evaData.map(({ eva_template_id, is_usage, title }) => ({
    checked: !!is_usage,
    text: title,
    id: eva_template_id
  }));
export const paramsEvalData = evaluatRes =>
  evaluatRes.map(({ id, starNum, suggest, contsList,typeObj = "" }) => ({
    user_id: id,
    star: starNum,
    typeObj: typeObj,
    other_eva: suggest,
    tag_list: contsList.map(({ id, checked }) => ({
      eva_id: id,
      is_option: starNum >=5 ? 0 : (checked ? 1 : 0)
    }))
  }));
export const transData = (arr, names, evaData, type = "",typeObj = "") =>
  arr.map((item, i) => ({
    id: item,
    type,
    typeObj,
    name: names[i],
    starNum: 0,
    suggest: "",
    contsList: transContsList(evaData)
  }));
